import { GET_LIMITS_BONUSES, GET_PREMIUM_LIST, GET_REGULAR_BONUSES } from "./../types";

export const fetchPremiumList = payload => ({
  type: GET_PREMIUM_LIST,
  payload
});

export const fetchLimitsBonusesList = () => ({
  type: GET_LIMITS_BONUSES
});

export const fetchRegularBonusesList = payload => ({
  type: GET_REGULAR_BONUSES,
  payload
});



// WEBPACK FOOTER //
// src/redux/actions/premiumActions.js